module.exports = __webpack_public_path__ + "static/icon-vision.a2bda05f.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/icon-vision.png
// module id = 295
// module chunks = 2